<template>
  <!-- 推荐公司 -->

  <div class="box1">
    <div class="Recommended-box">
      <!-- 搜索 -->
      <div class="search">
        <!-- 筛选选择 -->
        <div class="search-Select">
          <p
            class="search-Select-p"
            v-for="(item, index) in list"
            :key="index"
            :class="item.id == Toggle ? 'Select-p' : ''"
            @click="handelToggle(item.id)"
          >
            {{ item.name }}
          </p>
          <p
            v-if="
              intention.positionName !== '' &&
              intention.addressName != '' &&
              intention.positionName !== undefined &&
              intention.addressName != undefined
            "
            class="search-Select-p"
            :class="3 == Toggle ? 'Select-p' : ''"
            @click="handelToggle(3)"
          >
            {{ intention.positionName + " - " + intention.addressName }}
          </p>
        </div>
        <!-- 搜索框 -->
        <div class="search-Search">
          <el-input v-model="input" placeholder="搜索企业"></el-input>
          <div class="search_btn" @click="handelSearch">
            <div>
              <p><i class="el-icon-search"></i></p>
              搜 索
            </div>
          </div>
        </div>
        <!-- 开启关闭筛选按钮 -->
        <div class="screen-btn">
          <div class="screen-btn-box firm-clickable" @click="screen = !screen">
            <p>筛选</p>
            <div v-if="screen == 1" class="unfold-icon"></div>
            <div v-else class="PackUp-icon"></div>
          </div>
        </div>
      </div>
      <!-- 筛选 -->
      <div class="screen" v-if="screen">
        <corScreen
          @handelClickExp="handelClickExp"
          @handelClickScale="handelClickScale"
        ></corScreen>
      </div>

      <!-- 主体 -->
      <div class="Core">
        <!-- <corCore></corCore> -->
        <Firm :listArr="listArr" :distinguish="1" @Refresh="getRecommendHotCompany()"></Firm>
      </div>
      <!-- 分页 -->
      <div class="paging">
        <div class="paging-cen">
          <paging
            :pagingObj="pagingObj"
            @handleCurrentChange="handleCurrentChange"
          ></paging>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入推荐职位页的接口
import {
  getRecommendHotCompany,
  getUserHopePosition, // 查询用户首个求职意向
} from "../../../assets/api/Recommended";
// 引入 头部筛选搜索 组件
import corScreen from "./components/corScreen.vue";
// 引入 主体推荐职位 组件
// import corCore from "./components/corCore.vue";
// 引入分页组件
import paging from "../../../components/paging.vue";
// 引入 主体推荐职位 组件 （与index也公用）
import Firm from "../home/components/homes/Firm.vue";
export default {
  props: {
    cityCodeNum: {},
  },
  components: {
    corScreen,
    // corCore,
    paging,
    Firm,
  },
  data() {
    return {
      listArr: [],
      pagingObj: {
        currentPage: 1, //当前页
        pageSize: 15, // 一页显示多少个
        totalDevice: 0, //用户总数
      }, // 分页数据
      list: [
        { name: "推荐企业", id: "1" },
        { name: "搜索", id: "2" },
        // { name: "JAVA", id: "3" },
      ], // 导航数据
      Toggle: "1", // 切换
      input: "", //搜索
      screen: true, // 筛选
      cityCode: "", // 地址
      Exp: "", // 筛选公司行业
      scale: "", // 筛选 公司规模
      // objAddress: "", //选中的意向地址
      // objName: "", // 选中的意向名
      intention: {}, // 我的意向第一条
    };
  },
  watch: {
    // 监听页面
    input: {
      handler(newss, old) {
        if (newss == "") {
          this.getRecommendHotCompany();
        }
      },
      immediate: false,
    },
    // 监听页面
    cityCodeNum: {
      handler(newss, old) {
        if (
          localStorage.getItem("cityCode") == "001" ||
          localStorage.getItem("cityCode") == "002"
        ) {
          this.cityCode = "";
          this.getRecommendHotCompany();
        } else {
          this.cityCode = localStorage.getItem("cityCode");
          this.getRecommendHotCompany();
        }
      },
      immediate: false,
    },
  },
  created() {
    // 先检查用户是否登录，再获取用户求职意向接口
    if (this.$store.getters.getUser && this.$store.getters.getUser.id) {
      this.getUserHopePosition();
    }

    if (
      localStorage.getItem("cityCode") == "001" ||

      localStorage.getItem("cityCode") == "002"
    ) {
      this.cityCode = "";
      this.getRecommendHotCompany();
    } else {
      this.cityCode = localStorage.getItem("cityCode");
      this.getRecommendHotCompany();
    }
  },
  mounted() {},
  destroyed() {},
  methods: {
    //-------------------------- 查询用户首个求职意向 ------------
    async getUserHopePosition() {
      const res = await getUserHopePosition();
      if (res.data.length > 0) {
        // this.cityCode = res.data[0].addressCode;
        // this.objAddress = res.data[0].addressName;
        // this.objName = res.data[0].positionName;
        this.intention = res.data[0];
      }
    },
    // 热门公司 数据接口
    async getRecommendHotCompany() {
      var data = {
        data: {
          userId: this.$store.getters.getUser.id,
          regionCode: this.cityCode,
          industryTypeCode: this.Exp,
          companySizeId: this.scale,
          companyName: this.input,
        },
      };
      const res = await getRecommendHotCompany(
        data,
        this.pagingObj.currentPage, // 当前页
        this.pagingObj.pageSize // 一页几条
      );
      if (res.code == 0) {
        this.listArr = res.data.list;
        this.pagingObj.totalDevice = res.data.total;
      } else {
      }
    },
    // 重置分页
    pagingObjReset(){
      this.pagingObj = {
        currentPage: 1, //当前页
        pageSize: 15, // 一页显示多少个
        totalDevice: 0, //用户总数
      }; // 分页数据
    },
    // 推荐企业  搜索  意向职位
    handelToggle(num) {
      this.pagingObjReset()
      this.Toggle = num;
      if (num != 2) {
        this.input = "";
      }
      if (num == 3) {
        console.log("mum==3");
        this.Exp = this.intention.positionCode;
        this.cityCode = this.intention.addressCode;
        this.getRecommendHotCompany();
      } else {
        this.Exp = "";
        if (
          localStorage.getItem("cityCode") == "001" ||
          localStorage.getItem("cityCode") == "002"
        ) {
          this.cityCode = "";
          this.getRecommendHotCompany();
        } else {
          this.cityCode = localStorage.getItem("cityCode");
          this.getRecommendHotCompany();
        }
      }
    },
    // 搜索
    handelSearch() {
      this.pagingObjReset()
      this.getRecommendHotCompany();
      this.Toggle = "2";
    },
    // handelClickExp 企业行业筛选
    handelClickExp(val) {
      this.pagingObjReset()
      this.Exp = val;
      this.getRecommendHotCompany();
    },
    // 企业规模筛选
    handelClickScale(val) {
      this.pagingObjReset()
      this.scale = val;
      this.getRecommendHotCompany();
    },
    // 分页
    handleCurrentChange(num) {
      // num 要跳转的页面
      this.pagingObj.currentPage = num;
      // 调用数据接口
      this.getRecommendHotCompany();
    },
  },
};
</script>

<style scoped lang="less">
.box1 {
  width: 100%;
}
.Recommended-box {
  width: 100%;
  display: flex;
  flex-direction: column;
}
//搜索区
.search {
  min-width: 1136px;
  height: 30px;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;

  font-family: PingFangSC-Medium;
  font-weight: 400;
  // 搜索区 选择
  .search-Select {
    flex: 1;
    height: 28px;
    line-height: 28px;
    margin-right: 90px;

    display: flex;
    .search-Select-p {
      padding-left: 8px;
      padding-right: 8px;
      min-width: 90px;
      height: 28px;
      background: #eeeeee;
      border-radius: 5px;
      font-size: 14px;
      color: #999999;
      text-align: center;
      margin-right: 10px;
      cursor: pointer;
    }
    .Select-p {
      background: rgba(97, 144, 232, 0.2);
      border-radius: 5px;
      color: #409eff ;
    }
  }
  // // 搜索区意向职位
  // .intention{

  // }
  // 搜索区 搜索
  .search-Search {
    min-width: 310px;
    height: 30px;
    line-height: 30px;
    margin-right: 15px;
    display: flex;
    position: relative;
    // input框的样式
    /deep/.el-input__inner {
      width: 235px;
      font-size: 14px;
      line-height: 30px;
      height: 30px !important;
      box-sizing: border-box;
      border: 2px solid #409eff ;
      background: #ffffff;
      position: absolute;
      border-radius: 10px;
      z-index: 1;
    }
    // 搜索按钮样式
    .search_btn {
      font-size: 14px;
      color: #ffffff;
      font-weight: 400;
      line-height: 30px;
      background-color: #409eff ;
      width: 80px;
      border: 2px solid #409eff ;
      height: 26px;
      border-radius: 0px 10px 10px 0px;
      cursor: pointer;
      position: absolute;
      right: 0;
      display: flex;
      white-space: nowrap;
      div {
        width: 60px;
        height: 20px;
        line-height: 20px;
        margin: auto;
        display: flex;
        p {
          width: 20px;
          height: 20px;
          margin-right: 3px;
          cursor: pointer;
        }
      }
    }
  }
  // 筛选按钮
  .screen-btn {
    width: 85px;
    height: 28px;
    background: #409eff ;
    border-radius: 5px;
    display: flex;
    cursor: pointer;
    margin: auto 0;
    p {
      cursor: pointer;
    }
    .screen-btn-box {
      min-width: 10px;
      margin: auto;
      display: flex;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      color: #ffffff;
      font-weight: 400;
      .unfold-icon {
        width: 15px;
        height: 8px;
        background-image: url("../../../assets/imgs/arrow-drop-down-fill@3x.svg");
        background-size: 100% 100%;
        margin: auto 0;
        margin-left: 5px;
      }
      .PackUp-icon {
        width: 15px;
        height: 8px;
        background-image: url("../../../assets/imgs/arrow-drop-up-fill@3x.svg");
        background-size: 100% 100%;
        margin: auto 0;
        margin-left: 5px;
      }
    }
  }
}
// 筛选区
.screen {
  min-width: 1136px;
  background: #ffffff;
  margin: auto;
  box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
  border-radius: 10px;
  margin-bottom: 30px;
}
.Core {
  width: 1136px;
  // max-width: 1200px;
  min-height: 800px;
  margin: auto;
  margin-top: -15px;
}
.paging {
  min-width: 1200px;
  margin: auto;
  display: flex;
  margin-top: 40px;
  .paging-cen {
    margin: auto;
  }
}
</style>
